import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { useSignedUrl } from '@/hooks/useSignedUrl';

type BucketName = 'patient-photos' | 'shift-photos' | 'avatars' | 'company-logos';

interface SignedAvatarProps {
  src: string | null | undefined;
  bucket: BucketName;
  fallback: React.ReactNode;
  className?: string;
  alt?: string;
  signedUrl?: string | null;
}


/**
 * Avatar component that automatically fetches signed URLs for private storage buckets
 * Uses useSignedUrl hook with built-in caching and request deduplication
 */
export function SignedAvatar({ src, bucket, fallback, className, alt, signedUrl: propSignedUrl }: SignedAvatarProps) {
  // Use the hook with caching - pass null if propSignedUrl is provided
  const cachedSignedUrl = useSignedUrl(propSignedUrl ? null : src, bucket);

  const finalUrl = propSignedUrl || cachedSignedUrl;

  return (
    <Avatar className={className}>
      <AvatarImage src={finalUrl || undefined} alt={alt} />
      <AvatarFallback>{fallback}</AvatarFallback>
    </Avatar>
  );
}

